export const isMac = () => window.navigator.platform.toLowerCase().includes("mac");
export const isSafari = () =>
  navigator.userAgent.toLowerCase().includes("safari") &&
  !navigator.userAgent.toLowerCase().includes("chrome");
